import { Injectable } from "@angular/core";
import { BehaviorSubject, Observer, Subject, Subscription } from "rxjs";
import { ApiService } from "../services/api.service";
import { ApiServiceDelegate  } from "../models/api-service-delegate";
import { NzMessageService } from "ng-zorro-antd/message";
import { LoginComponent } from "../login/login.component";
import { ApiCollection } from "../providers/api-collection";
import { PriorityResponseModel, TaskCommentResponseModal, TaskResponseModel, TaskStatusResponseNodel,  UserGroupResponseModel,   UserResponseModel } from "../models/task.model";
import { HttpEventType, HttpResponse } from "@angular/common/http";
import { QuickAddService } from "../services/quick-add.service";
import { TasksComponent } from "../pages/tasks/tasks.component";
import { ConsoleTaskTabComponent } from "../components/console-task-tab/console-task-tab.component";
import { TaskDrawerComponent } from "../components/task-drawer/task-drawer.component";
import { CpdFilesComponent } from "../components/console-project-detail/cpd-files/cpd-files.component";

@Injectable({
    providedIn: "root",
})

export class TaskViewModel {

    parentTasksComponent: TasksComponent;
    consoleTaskTabComponent:ConsoleTaskTabComponent;
    parentTaskDrawerComponent: TaskDrawerComponent;
    parentCpdFilesComponent: CpdFilesComponent;

    constructor(
        private apiService: ApiService,
        private message: NzMessageService,
        private quickAddService: QuickAddService
    ) { }
     errorService = new Subject()
     taskDataList = new BehaviorSubject<TaskResponseModel>(new TaskResponseModel())
     taskData = new BehaviorSubject<any>(null)
     taskStatusList = new BehaviorSubject<TaskStatusResponseNodel>(new TaskStatusResponseNodel())
     userGroupList = new BehaviorSubject<UserGroupResponseModel>(new UserGroupResponseModel())
     userList = new BehaviorSubject<UserResponseModel>(new UserResponseModel())
     priorityList = new BehaviorSubject<PriorityResponseModel>(new PriorityResponseModel())
     taskComment  = new BehaviorSubject<TaskCommentResponseModal>(new TaskCommentResponseModal())
     historyList = new Subject()


    subscribeToTasks(observer: Observer<TaskResponseModel>){
        this.taskDataList.subscribe(observer);
    }

    getTaskList(page:number,page_size:number,name:string = '',filterObject:any={}, requestSeq?:number ){
            let url = ApiCollection.Task +'?page='+page+'&page_size='+page_size + '&sort_by=id&sort_type=desc';
            if(name.length > 0){
                url += '&name='+name;
            }
          for(const [key, value ] of Object.entries(filterObject)){
            if(value != null && value != undefined && value != ''){
                if(Array.isArray(value)){
                    // Multi-select filters share the existing single-value query key; selected
                    // ids are joined with a comma into one value rather than repeating the key.
                    if(value.length > 0){
                        url += '&' + key + '=' + value.join(',')
                    }
                } else{
                    url += '&' + key + '=' + value
                }
            }
          }

            let d: ApiServiceDelegate = {
                Data: {},
                Method: "GET",
                Action: url,
                // Action: name ?  ApiCollection.Task +'?page='+page+'&page_size='+page_size + '&name='+name : ApiCollection.Task +'?page='+page+'&page_size='+page_size,
                Success: (e: any) => {
                   this.taskDataList.next(e)
                   this.parentTasksComponent.taskReceived(requestSeq);
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                    return e;
                },
                Error: (e: String) => {
                    this.errorService.next(e)
                    // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                    return e;
                },
            };
            this.apiService.callService(d);
        }

    getTaskById(id:number, caller?: string){
            let d: ApiServiceDelegate = {
                Data: {},
                Method: "GET",
                Action:   ApiCollection.Task + '/'+id  ,
                Success: (e: any) => {
                   this.taskData.next(e)
                   this.consoleTaskTabComponent.taskDataReceived();
                return e;
                },
                Error: (e: String) => {
                    this.consoleTaskTabComponent.taskDataReceived();
                     const allErrors = Object.values(e).flat();
                    allErrors.forEach(element => {
                        this.message.error(String(element), { nzDuration: 2000 });
                    });
                    return e;
                },
            };
            this.apiService.callService(d);
        }

        deleteTaskById(id:number){
            let d: ApiServiceDelegate = {
                Data: {},
                Method: "DELETE",
                Action:   ApiCollection.Task + '/'+id  ,
                Success: (e: any) => {
                    this.consoleTaskTabComponent.taskDeleted();
                    this.message.success("Tasks deleted successfully", {nzDuration: 1000});
                    return e;
                },
                Error: (e: String) => {
                    this.message.error(String(e), {nzDuration: 1000});
                    console.log(e);
                    return e;
                },
            };
            this.apiService.callService(d);
        }


    getTaskStatusList(page:number,page_size:number){
            let d: ApiServiceDelegate = {
                Data: { },
                Method: "GET",
                Action: ApiCollection.Task_status +'?page='+page+'&page_size='+page_size,
                Success: (e: any) => {
                   this.taskStatusList.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                    return e;
                },
                Error: (e: String) => {
                    // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                    return e;
                },
            };
            this.apiService.callService(d);
        }

    getUserGroupList(page:number,page_size:number){
            let d: ApiServiceDelegate = {
                Data: { },
                Method: "GET",
                Action: ApiCollection.User_group +'?page='+page+'&page_size='+page_size,
                Success: (e: any) => {
                   this.userGroupList.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                    return e;
                },
                Error: (e: String) => {
                    // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                    return e;
                },
            };
            this.apiService.callService(d);
        }

    getUserList(page:number,page_size:number,name?:string,userGroupParam?:number){
        let url = ApiCollection.User +'?page='+page+'&page_size='+page_size+'&is_deleted=false';
        if(name){
            url += '&name='+name;
        }
        if(userGroupParam){
            url += '&user_group=' + userGroupParam;
        }
            let d: ApiServiceDelegate = {
                Data: { },
                Method: "GET",
                Action: url,
                Success: (e: any) => {
                   this.userList.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                    return e;
                },
                Error: (e: String) => {
                    // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                    return e;
                },
            };
            this.apiService.callService(d);
        }

    getPriorityList(page:number,page_size:number){
            let d: ApiServiceDelegate = {
                Data: { },
                Method: "GET",
                Action: ApiCollection.Priority +'?page='+page+'&page_size='+page_size,
                Success: (e: any) => {
                   this.priorityList.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                    return e;
                },
                Error: (e: String) => {
                    // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                    return e;
                },
            };
            this.apiService.callService(d);
        }

        getTaskCommentList(taskId:any){
            let d: ApiServiceDelegate = {
                Data: { },
                Method: "GET",
                Action: ApiCollection.Task_Comment +'?task=' + taskId,
                Success: (e: any) => {
                   this.taskComment.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                    return e;
                },
                Error: (e: String) => {
                    // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                    return e;
                },
            };
            this.apiService.callService(d);
        }

        createTaskComment(data){
            let d: ApiServiceDelegate = {
                Data:data,
                Method: "POST",
                Action: ApiCollection.Task_Comment,
                Success: (e: any) => {
                //    this.taskComment.next(e)
                this.consoleTaskTabComponent.taskCommentadded()
                   this.message.success("Tasks comment created successfully", {nzDuration: 1000});
                    return e;
                },
                Error: (e: String) => {
                    // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                    return e;
                },
            };
            this.apiService.callService(d);
        }

        updateTaskComment(data: any) {
            let d: ApiServiceDelegate = {
                Data: { comment: data.comment },
                Method: "PATCH",
                Action: ApiCollection.Task_Comment + '/' + data.id,
                Success: (e: any) => {
                    this.message.success("Comment updated", { nzDuration: 1000 });
                    this.consoleTaskTabComponent.taskCommentadded();
                    return e;
                },
                Error: (e: String) => { return e; },
            };
            this.apiService.callService(d);
        }

        updateTaskCommentList(data){
            let d: ApiServiceDelegate = {
                Data:data,
                Method: "PATCH",
                Action: ApiCollection.Task_Comment,
                Success: (e: any) => {
                   this.taskComment.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                    return e;
                },
                Error: (e: String) => {
                    // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                    return e;
                },
            };
            this.apiService.callService(d);
        }

        deleteMediaFile(data){
            let d: ApiServiceDelegate = {
                Data:data,
                Method: "DELETE",
                Action: ApiCollection.Media + '/' + data,
                Success: (e: any) => {
                    this.parentCpdFilesComponent.fileDeleted()
                    this.message.success("File deleted successfully!", {nzDuration: 1000});
                    return e;
                },
                Error: (e: String) => {
                    // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                    return e;
                },
            };
            this.apiService.callService(d);
        }

        uploadMediaFile(item: any, userId: any): Subscription {
            const formData = new FormData();
            formData.append('file', item.file as File);
            formData.append('name', item.file.name);
            formData.append('created_by', userId);

            return this.apiService.uploadFileWithProgress(ApiCollection.Media, formData).subscribe({
              next: (event) => {
                if (event.type === HttpEventType.UploadProgress) {
                  const percentDone = Math.round((100 * event.loaded) / (event.total || 1));
                  item.onProgress!({ percent: percentDone }, item.file);
                } else if (event instanceof HttpResponse) {
                  item.onSuccess!(event.body, item.file, event);
                }
              },
              error: (error) => {
                item.onError!(error, item.file);
              },
              complete: () => {
                console.log('Upload process completed.');
              }
            });
          }



    createTask(data:any){
        let d: ApiServiceDelegate = {
            Data: data,
            Method: "POST",
            Action: ApiCollection.Task,
            Success: (e: any) => {
                this.parentTaskDrawerComponent.successCreateUpdate(e);
                this.message.success("Task created successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                this.message.error(String(e), {nzDuration: 1000});
                console.log(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    updateTask(data:any, id:number, caller:string){
        let d: ApiServiceDelegate = {
            Data: data,
            Method: "PATCH",
            Action: ApiCollection.Task + '/' + id,
            Success: (e: any) => {
                if(caller == 'task-drawer'){
                  this.parentTaskDrawerComponent.successCreateUpdate(e);
                }

                this.message.success("Task updated successfully", {nzDuration: 1000});
            return e;
            },
            Error: (e: String) => {
                this.message.error(String(e), {nzDuration: 1000});
                console.log(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getTaskHistoryId(id?:number){
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action:   ApiCollection.Task + '/'+id + '/history' + '?page=1&page_size=100'  ,
            Success: (e: any) => {
               this.historyList.next(e)
            //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

}
